import { Button } from '@sweep-io/sweep-design';
import { styled } from '@mui/material';
import { AgentFileInvalid } from '../aiAgentsConsts';
import { uniqueId } from '../../../lib/uniqueId';
import { AgentFileAllowedExtension } from '@server/ai';
import { humanizeFileSize } from '../../helpers/humanizeFileSize';
import { ButtonSize } from '@sweep-io/sweep-design/dist/components/Button/types';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

const FilesUploadButton = ({
  startIconName,
  onAddValidFiles,
  onAddInvalidFiles,
  size,
  disabled,
}: {
  startIconName: string;
  onAddValidFiles: (files: File[]) => void;
  onAddInvalidFiles: (agentFiles: AgentFileInvalid[]) => void;
  size: ButtonSize;
  disabled?: boolean;
}) => {
  const onAdd = async (fileList: FileList | null) => {
    if (!fileList) {
      return;
    }
    const files = Array.from(fileList);
    const validFiles = files.filter((file) => file.size <= MAX_FILE_SIZE);
    const invalidFiles = files.filter((file) => file.size > MAX_FILE_SIZE);

    const agentFilesInvalid: AgentFileInvalid[] = invalidFiles.map((file) => {
      const pointIndex = file.name.lastIndexOf('.');
      const fileName = pointIndex !== -1 ? file.name.slice(0, pointIndex) : file.name;
      return {
        id: uniqueId(),
        name: fileName,
        message: `File upload failed. The file size must not exceed ${humanizeFileSize(MAX_FILE_SIZE)}.`,
      };
    });

    if (validFiles.length > 0) {
      onAddValidFiles(validFiles);
    }
    if (agentFilesInvalid.length > 0) {
      onAddInvalidFiles(agentFilesInvalid);
    }
  };

  const supportedExtensions = Object.values(AgentFileAllowedExtension)
    .map((ext) => '.' + ext)
    .join(',');

  return (
    // @ts-ignore  TODO add "files upload button" to the design system
    <Button size={size} startIconName={startIconName} component="label" disabled={disabled}>
      Add files
      <VisuallyHiddenInput
        type="file"
        accept={supportedExtensions}
        multiple
        onChange={(e) => onAdd(e.target.files)}
      />
    </Button>
  );
};

export default FilesUploadButton;
